export default "__VITE_ASSET__20b44703__"